module.exports = __webpack_public_path__ + "static/media/helloImage.e5f82052.png";